import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  banner: {
    backgroundColor: 'var(--blue-500)',
    color: 'var(--white)',
    px: '32px',
    py: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: '16px'
  } satisfies SxProps<Theme>,
  bannerText: {
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  bannerButton: {
    textTransform: 'none',
    backgroundColor: 'var(--white)',
    color: 'var(--blue-500)',
    boxShadow: 'none',
    justifyContent: 'space-between',
    minWidth: '150px',
    '&:hover': { backgroundColor: 'var(--grey-50)', boxShadow: 'none' }
  } satisfies SxProps<Theme>
}
